import { useSelector } from "react-redux";

import { getBooleanFeatureGateEnabled } from "@gamedev-web/gamedev-sdk-core";

import { BaseRootState } from "../../redux";

export type WithFeatureGateProps = Readonly<{
  featureGate: string;
  renderEnabled?: () => JSX.Element | null;
  renderDisabled?: () => JSX.Element | null;
  children?: never;
}>;

export const WithFeatureGate = ({
  featureGate,
  renderEnabled,
  renderDisabled,
}: WithFeatureGateProps) => {
  const isEnabled = useSelector((state: BaseRootState) =>
    getBooleanFeatureGateEnabled(state, featureGate)
  );
  if (isEnabled) {
    return renderEnabled ? renderEnabled() : null;
  }

  return renderDisabled ? renderDisabled() : null;
};
